<template>
    <div class="end">
        <div class="til">
            <div>
                <img src="../assets/img/test.png" alt="">
            </div>
            <div class="gup">
                <div class="w1">測驗結果</div>
                <div class="w2">題目： {{total}} 題</div>
            </div>
        </div>
        <div class="mm">
            <div class="m1">答對<br>{{num}}題</div>
            <div class="m2">正確率<br>{{pa}} %</div>
        </div>
        <div class="message">{{AddExamRecordMessage}}</div>
        <div class="next-bn bn" @click="onNext" v-if="hasNext">{{$t('nextTest')}}</div>
    </div>
</template>
<script>
import examDelegate from '@/delegate/examDelegate'
import mainDelegate from '@/delegate/mainDelegate'
export default {
    name: 'ExamEnd',
    mixins: [mainDelegate, examDelegate],
    props: ['total', 'num', 'pa'],
    computed: {
        hasNext() {
            return (
                this.lessonExamListIndex >= 0 &&
                this.lessonExamListIndex < this.lessonExamList.length - 1
            )
        }
    },
    methods: {
        onNext() {
            this.lessonExamListIndex += 1
        }
    }
}
</script>
<style lang="less" scoped>
@import 'val.less';
.end {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.til {
    height: 60px;
    margin: 40px 0px 28px 0px;
    display: inline-block;
    > div {
        float: left;
    }
    .gup {
        padding: 0px 17px;
        text-align: left;
        .w1 {
            line-height: 42px;
            font-size: 30px;
            color: @main-color;
            font-weight: bold;
        }
        .w2 {
            line-height: 28px;
            font-size: 20px;
        }
    }
}
.mm {
    width: 100%;
    height: 154px;
    display: flex;
    justify-content: center;
    > div {
        width: 130px;
        height: 154px;
        padding: 56px 0px 0px 0px;
        margin: 0px;
        box-sizing: border-box;
        font-size: 30px;
        color: #fff;
    }
    .m1 {
        background: url('../assets/img/test-answer.png');
        margin-right: 20px;
        color: #006df0;
    }
    .m2 {
        background: url('../assets/img/test-answer-good.png');
        color: #ff7081;
    }
}
.next-bn {
    background: @main-color;
    width: 300px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    border-radius: 5px;
    margin-top: 30px;
}
.message {
    margin-top: 32px;
    font-size: 18px;
    color: #444444;
}
</style>



// WEBPACK FOOTER //
// src/components/ExamEndView.vue